import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-desc",
  "use": "icon-desc-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-desc\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M11.2,14h1.6v1.6H11.2Zm0-1.2h1.6V8.4H11.2Zm7.9-.8A7.1,7.1,0,1,1,12,4.9,7.1,7.1,0,0,1,19.1,12ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol